import { render, staticRenderFns } from "./DictStRepFormColListPage.vue?vue&type=template&id=b4162d14&"
import script from "./DictStRepFormColListPage.vue?vue&type=script&lang=ts&"
export * from "./DictStRepFormColListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports